import React from 'react';
import HBox from '../layout/HBox';

type CampoRadioProps = {
  id: string;
  type?: 'radio' | 'checkbox';
  name?: string;
  label: string | React.ReactNode;
  checked: boolean;
  value?: string;
  onChange: (v: string) => void;
  disabled?: boolean;
  inline?: boolean;
  [key: string]: any;
};

const CampoRadio = (props: CampoRadioProps) => {
  return (
    <div style={{ width: '100%' }}>
      <label>
        <HBox>
          <input
            type="radio"
            id={props.id}
            name={props.name}
            checked={props.checked}
            value={props.value}
            onChange={e => props.onChange(e.target.value)}
            disabled={props.disabled}
            style={{ width: '24px' }}
          />
          <span>{props.label}</span>
        </HBox>
      </label>
    </div>
  );
};

export default CampoRadio;
